import React from 'react'

export enum BANNER_TYPES {
    FILTERS = 'Filters',
    LINK_AND_IMAGE = 'Link and Image',
    CATEGORIES = 'Categories',
    FACETS = 'Facets'
}

export enum layoutTypeEnum {
    scroll = 'scroll',
    grid = 'grid',
    wrap = 'wrap'
}

export type PlpBuilderBlockProps = {
    attributes?: {
        className?: string
        restAttributes?: React.HTMLAttributes<HTMLDivElement>
    }
    perPageLimit?: number
    accountFormLabels?: Record<string, unknown>
    injectedContentItems?: Record<string, unknown>[]
    customCrumbs?: Record<string, unknown>[]
    categoryCrumbs?: Record<string, unknown>[]
    separator?: string
    includeHome?: boolean
    builderBlock?: Record<string, unknown>
    showFilters?: boolean
    override?: boolean
    filterType?: BANNER_TYPES
    layoutType?: layoutTypeEnum
    list?: Array<Record<string, string>>
    links?: Array<Record<string, string>>
    facets?: Array<{name: string; value: string; display_name?: string}>
    iconSizeSmall?: string | undefined
    iconSizeLarge?: string | undefined
}
